import { request } from "./Request";
import { routes } from "../constants/constant.route";
import { urlConstants } from "../utils/urlConstants";
import {
  hasTrackedStudentHistory,
  markStudentHistoryTracked,
} from "../utils/studentHistoryTracker";

const { API_URL } = urlConstants;
const HISTORY_PATH = routes.STUDENT.STUDENT_HISTORY;

/**
 * POST /api/student/history/ at most once per login session for this user+role.
 */
export const postStudentHistoryOnce = (body) => {
  if (hasTrackedStudentHistory(body)) {
    return Promise.resolve({ skipped: true, status: 200, data: null });
  }

  return request("POST", `${API_URL}${HISTORY_PATH}`, null, body, null, null, null)
    .then((res) => {
      markStudentHistoryTracked(body);
      return res;
    })
    .catch((error) => {
      // Do not mark as tracked on failure so a later visit can retry once
      throw error;
    });
};

export default class StudentHistoryService {
  static trackOnce = (body) => postStudentHistoryOnce(body);
}
